module.exports = __webpack_public_path__ + "static/media/ic-fix-health.9ef2f450.svg";